"use server"; // Important if calling directly from a client component in Next.js
const baseUrl = process.env.NEXT_PUBLIC_BASE_URL;
const CMS_URL = `${baseUrl ? baseUrl : 'https://prerelease.designic.com'}/wp-json/api/v1/content/`;

export default async function cmsMail(payload) {
  const username = process.env.CMS_USER || "designic";
  const password = process.env.CMS_PASS || "d3s1gn1c";
  const basicAuth = Buffer.from(`${username}:${password}`).toString("base64");

  const url = `${CMS_URL.replace(/\/$/, "")}/mail`;

  const res = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Basic ${basicAuth}`,
    },
    // This is where the body gets attached to the request
    body: JSON.stringify(payload), 
  });

  if (!res.ok) {
    throw new Error(`CMS error: ${res.status} ${res.statusText}`);
  }

  return res.json();
}